export const apiTags = {
	messages: 'messages',
	shop: 'shop',
	contacts: 'contacts',
	grid: 'grid',
	gifts: 'gifts',
	subscriptions: 'subscriptions',
	imagesGenerationBots: 'imagesGenerationBots',
	imagesGenerationQuota: 'imagesGenerationQuota',
	characterGenerationQuota: 'characterGenerationQuota',
	generatedMedia: 'generatedMedia',
	generatedPublicMedia: 'generatedPublicMedia',
	tags: 'tags',
	userProps: 'userProps',
	userConfig: 'userConfig',
	videosGenerationBots: 'videosGenerationBots',
	videosGenerationQuota: 'videosGenerationQuota',
	liveops: 'liveops',
	botGallery: 'botGallery',
};
